package com.royceecoleman.bill.settings

import com.royceecoleman.bill.auth.authenticatedFetch
import com.royceecoleman.bill.shared.aichat.ManagedAiModelDto
import com.royceecoleman.bill.shared.aichat.ManagedAiModelUpdateRequest
import kotlinx.coroutines.await
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val AI_MODEL_SETTINGS_BASE_PATH = "/api/settings/ai-models"

private val settingsJson =
    Json {
        ignoreUnknownKeys = true
        explicitNulls = false
    }

suspend fun fetchManagedAiModels(): List<ManagedAiModelDto> = requestJson(AI_MODEL_SETTINGS_BASE_PATH, "GET")

suspend fun saveManagedAiModel(request: ManagedAiModelUpdateRequest): ManagedAiModelDto =
    requestJson(
        path = AI_MODEL_SETTINGS_BASE_PATH,
        method = "POST",
        body = settingsJson.encodeToString(request),
    )

suspend fun setDefaultManagedAiModel(modelId: String): ManagedAiModelDto =
    requestJson(
        path = "$AI_MODEL_SETTINGS_BASE_PATH/${encodeModelId(modelId)}/default",
        method = "PUT",
        body = "{}",
    )

suspend fun deleteManagedAiModel(modelId: String): ManagedAiModelDto =
    requestJson(
        path = "$AI_MODEL_SETTINGS_BASE_PATH/${encodeModelId(modelId)}",
        method = "DELETE",
    )

internal fun encodeModelId(modelId: String): String = encodeURIComponent(modelId)

private suspend inline fun <reified T> requestJson(
    path: String,
    method: String,
    body: String? = null,
): T {
    val response =
        authenticatedFetch(
            path = path,
            method = method,
            body = body,
            contentType = body?.let { "application/json" },
        )
    val responseText = response.text().await()

    if (!response.ok) {
        throw IllegalStateException(responseText.ifBlank { "Request to $path failed with status ${response.status}." })
    }

    return settingsJson.decodeFromString(responseText)
}

private external fun encodeURIComponent(value: String): String
